<!--Footer-->
<footer class="p-4 p-sm-5">
  <div class="container text-center">
    <div class="text-center small mb-3 text-muted">
      <a href="https://insureco.io/#/legal/terms" class="text-muted mr-3">Terms of use</a>
      <a href="https://insureco.io/#/legal/privacy" class="text-muted mr-3">Privacy policy</a>
      <a href="https://insureco.atlassian.net/servicedesk/customer/portals" class="text-muted mr-3">Support</a>
      <a href="https://insureco.io/#/about-us/contact" class="text-muted mr-3">Contact</a>
      <br />
      © 2024 InsurEco Inc, All rights reserved.
    </div>
  </div>
</footer>